import SettingProps from "../SettingProps";
// import CSSSetting from "../csssetting/CSSSetting";
import GenericSetting, {StyleSettingType} from "../genericsetting/GenericSetting";

export default function PixelDimensionSetting(props: SettingProps) {
    // return <CSSSetting {...props} title={"Dimension"}  type={"dimension"} targets={["max-width" , "max-height" ,"min-width", "min-height","width","height"]}/>
    return <GenericSetting {...props}
                           title={"Dimension"}
                           type={"dimension"}
                           targets={[
                                    { name: "Max Width",target: 'max-width' , type: StyleSettingType.px_only_size},
                                    { name: "Min Width", target: 'min-width' , type: StyleSettingType.px_only_size},
                                    { name: "Width", target: 'width' , type: StyleSettingType.px_only_size},
                                    { name: "Max Height", target: 'max-height' , type: StyleSettingType.px_only_size},
                                    { name: "Min Height", target: 'min-height' , type: StyleSettingType.px_only_size},
                                    { name: "Height", target: 'height' , type: StyleSettingType.px_only_size}
                                ]}
        />
}